import { ENDPOINTS } from '../endpoints';
import {
  CreateIdTypeDto,
  CreatePrivilegeDto,
  CreateRoleDto,
  CreateUserDto,
  IdTypeDto,
  PrivilegeDto,
  RoleDto,
  UpdateIdTypeDto,
  UpdatePrivilegeDto,
  UpdateRoleDto,
  UpdateUserDto,
  UserDto,
} from '../types/dtos';
import { BaseService } from './base.service';
import { apiClient } from '../client/axiosClient';
import { CustomResponseEntity } from '../types/common';

export class UserService extends BaseService<UserDto, CreateUserDto, UpdateUserDto> {
  constructor() {
    super(ENDPOINTS.users.base());
  }
}

export class RoleService extends BaseService<RoleDto, CreateRoleDto, UpdateRoleDto> {
  constructor() {
    super(ENDPOINTS.roles.base());
  }

  async findByOrganization(organizationId: string): Promise<CustomResponseEntity<RoleDto[]>> {
    const response = await apiClient.get(ENDPOINTS.roles.byOrganization(organizationId));
    // response is already unwrapped by axios interceptor, so response is the CustomResponseEntity
    return response as unknown as CustomResponseEntity<RoleDto[]>;
  }
}

export class PrivilegeService extends BaseService<PrivilegeDto, CreatePrivilegeDto, UpdatePrivilegeDto> {
  constructor() {
    super(ENDPOINTS.privileges.base());
  }
}

export class IdTypeService extends BaseService<IdTypeDto, CreateIdTypeDto, UpdateIdTypeDto> {
  constructor() {
    super(ENDPOINTS.idTypes.base());
  }
}

// Service instances
export const userService = new UserService();
export const roleService = new RoleService();
export const privilegeService = new PrivilegeService();
export const idTypeService = new IdTypeService(); 